/* Material */
import Link from '@mui/material/Link'
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined'
import { Theme, alpha } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

/* Components */
import NoBr from './js_elements/NoBr'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0, 1fr)',
      gap: theme.spacing(1),
      alignItems: 'flex-start',
      border: `1px solid ${alpha(theme.palette.text.primary, .08)}`,
      borderRadius: 8,
      padding: theme.spacing(1.1, 1.25),
      backgroundColor: 'var(--page-builder-surface, rgba(255, 255, 255, .72))',
      color: 'var(--page-builder-muted, inherit)',
      boxShadow: '0 8px 22px rgba(15, 23, 42, .04)',
      '& a': {
        color: 'inherit',
        textDecorationColor: 'currentColor',
      },
    },
    icon: {
      color: `var(--page-builder-info, ${theme.palette.info.main})`,
      fontSize: '1.15rem',
      marginTop: 1,
    },
    title: {
      color: 'var(--page-builder-text, inherit)',
      fontWeight: 700,
      marginBottom: theme.spacing(.25),
    },
  })
)

const GoogleRecaptchaInfos = () => {
  const classes = useStyles()

  return <div className={classes.root}>
    <SecurityOutlinedIcon className={classes.icon} />
    <div>
      <div className={classes.title}>Unsichtbarer Spam-Schutz</div>
      Diese Website nutzt reCAPTCHA im Hintergrund. Es gelten die {' '}
      <NoBr><Link href="https://policies.google.com/privacy">Datenschutzbestimmungen</Link></NoBr> und {' '}
      <NoBr><Link href="https://policies.google.com/terms">Nutzungsbedingungen</Link></NoBr> von Google.
    </div>
  </div>
}

export default GoogleRecaptchaInfos
